import React from 'react';
import styles from './styles.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUpload } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import { faEye } from '@fortawesome/free-solid-svg-icons'
import services from '../../../../../services';

const Card = ({ usuario, parceiro, permiteAlterar, permiteVisualizar }) => {

    const history = useHistory();

    return (
        <div className={styles.wrapper}>
            {
                usuario.nomeParticipante ?
                    (
                        <>
                            <div className={styles.title}>
                                Nome:
                            </div>
                            <div className={styles.info}>
                                {usuario.nomeParticipante}
                            </div>
                        </>
                    ) : null
            }
            {
                usuario.email ?
                    (
                        <>
                            <div className={styles.title}>
                                Email:
                            </div>
                            <div className={styles.info}>
                                {usuario.email}
                            </div>
                        </>
                    ) : null
            }
            {
                usuario.cpf ?
                    (
                        <>
                            <div className={styles.title}>
                                CPF
                            </div>
                            <div className={styles.info}>
                                {services.mask.cpf(usuario.cpf)}
                            </div>
                        </>
                    ) : null
            }
            {
                usuario.cargo ?
                    (
                        <>
                            <div className={styles.title}>
                                Cargo
                            </div>
                            <div className={styles.info}>
                                {usuario.cargo}
                            </div>
                        </>
                    ) : null
            }
            {
                usuario.perfilAcesso ?
                    (
                        <>
                            <div className={styles.title}>
                                Perfil de acesso
                            </div>
                            <div className={styles.info}>
                                {usuario.perfilAcesso}
                            </div>
                        </>
                    ) : null
            }
            <div className={styles.actionWrapper}>
                {usuario.status === "Ativo" ? (<div className={styles.andamento}>ATIVO</div>) : (<div className={styles.encerrado}>INATIVO</div>)}

                {
                    (permiteAlterar) ? (
                        <button className={styles.editar} onClick={() => { history.push(`/participantes?parceiro=${parceiro}&participante=${usuario.participanteId}&status=${usuario.status}&acao=A`) }}>
                            Editar
                            <FontAwesomeIcon icon={faUpload} className={styles.icon} />
                        </button>
                    ) : null
                }

                {
                    permiteVisualizar && (
                        <button className={styles.visualizar} onClick={() => { history.push(`/participantes?parceiro=${parceiro}&participante=${usuario.participanteId}&status=${usuario.status}`) }}>
                            Visualizar
                            <FontAwesomeIcon icon={faEye} className={styles.icon} />
                        </button>
                    )
                }
            </div>
        </div>
    )
}

export default Card